import React from 'react';

const Return = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="18"
      viewBox="0 0 11 18"
    >
      <g>
        <g>
          <path
            fill="none"
            stroke="#e84249"
            strokeLinecap="round"
            strokeMiterlimit="20"
            strokeWidth="2"
            d="M10 1v0L2 9v0l8 8v0"
          />
        </g>
      </g>
    </svg>
  );
};

export default Return;
